import { i18nConfig, LOCALES_PATH } from '@/config/settings'
import i18next from 'i18next'
import Backend, { type HttpBackendOptions } from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

void i18next
  .use(initReactI18next) // Tell i18next to use the react-i18next plugin
  .use(Backend) // Setup your backend
  .init<HttpBackendOptions>({
    ...i18nConfig, // spread the configuration
    // This function detects the namespaces your routes rendered while SSR use
    backend: { loadPath: LOCALES_PATH },

    detection: {
      // Here only enable htmlTag detection, we'll detect the language only
      // server-side with remix-i18next, by using the `<html lang>` attribute
      // we can communicate to the client the language detected server-side
      order: ['htmlTag'],
      // Because we only use htmlTag, there's no reason to cache the language
      // on the browser, so we disable it
      caches: [],
    },
  })
